export default {
    path: 'statistics',
    name: 'StatisticsForm',
    component() {
        return import('@/components/statistics/StatisticsForm.vue')
    },
    children: [
        {
            path: '',
            name: 'Statistics',
            component() {
                return import('@/components/statistics/Statistics.vue')
            },
        },
    ],
}